export default __webpack_public_path__ + "static/media/blog_template.0b6d9f38.png";